import * as React from 'react';
import NavHelper from '../components/NavHelper';

enum FormState {
  PRISTINE,
  SUCCESS,
  ERROR
}
export interface VolunteeringState {
  name: string;
  email: string;
  volunteer_area: string;
  phone: string;
  formState: FormState;
  message: string;
}

const setStateOnInput = (fieldName: string, text: string, state: object): object => {
  const nextState = {
    ...state,
    [fieldName]: text,
  };
  return nextState;
};

const EMAIL_URL = 'https://gnesb8xok7.execute-api.ap-southeast-2.amazonaws.com/dev/mail';
class Volunteering extends React.PureComponent<{}, VolunteeringState> {

  constructor(props: React.ReactPropTypes) {
    super(props);
    this.state = { formState: FormState.PRISTINE, name: '', email: '', volunteer_area: '', phone: '', message: '' };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event: React.FormEvent) {
    const element = event.currentTarget as HTMLInputElement;
    this.setState(setStateOnInput(element.name, element.value, this.state));
  }

  async handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    const result = await fetch(EMAIL_URL, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // no-referrer, *client
      body: JSON.stringify(this.state), // body data type must match "Content-Type" header
    });

    if (result.ok) {
      this.setState({ formState: FormState.SUCCESS });
    } else {
      this.setState({ formState: FormState.ERROR });
    }
  }

  render(): JSX.Element {
    return (
      <div>
        <NavHelper pageName="Volunteering" icon="fa-gittip" />
        <section id="main-content" className="main-content pad-60">
          <div className="container">
            <div className="row">
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/volunteering/computer-class.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
              <div className="col-sm-8 col-xs-12">
                <div className="article pad-b-60">

                  <h2>Hey there!</h2>
                  <p>Have you always wanted to be part of a meaningful project? Do you love traveling but also want to give back to the local communities? Volunteer for Pro-Ema and fulfill invaluable tasks as you change the life of many young adolescents women and support the local community.We have various opportunities that can suit you. Volunteers with a knack for teaching, business development, tech skills or financial knowledge will find countless opportunities to apply their skills and help our Organisation.</p>
                  <p>We look for passionate, skilled and committed people and match them to specific volunteering opportunities.
If you’re interested in becoming a key member of a our NGO – then we want you!”</p>
                </div> {/*/.article*/}
              </div>
            </div> {/*/.row*/}
            <div className="row">
              <div className="col-sm-8 col-xs-12">
                <div className="article">
                  <h2>Partnerships</h2>
                  <p>Strategic partnerships are an integral part of seeing our vision come to life. We would love to partner with you. If you’d like to know more about another kind of partnership, use the contact form below and let’s start a conversation about how we can work to help the Timorese young women rewrite their stories.</p>
                </div> {/*/.article*/}
              </div>
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/volunteering/cooking-class.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
            </div> {/*/.row*/}
            <div className="row">
              <div className="col-md-12">
                {/* contact form start */}
                <div className="contact-form">
                  <h3>Sign up to volunteer</h3>
                  <p>Send an Email. All fields with an * are required.</p>
                  <div className="row">
                    {this.state.formState === FormState.SUCCESS &&
                      <div className="alert alert-success" role="alert">
                        <strong>Well done!</strong> We will contact you back as soon as we can with more details.
                          </div>}
                    {this.state.formState === FormState.ERROR &&

                      <div className="alert alert-danger" role="alert">
                        <strong>Oh snap!</strong> There is something wrong with our system. You can email us directly at proema.timorleste@gmail.com
                          </div>
                    }
                  </div>
                  <div className="row">
                    <form className="form-inline" id="contactForm" name="contact" data-toggle="validator" onSubmit={this.handleSubmit}>
                      <div className="form-sec1">
                        <div className="col-md-3 col-xs-12">
                          <div className="form-group">
                            <label htmlFor="name">Name <b>*</b></label>
                            <input type="text" className="form-control" id="name" name="name" onChange={this.handleInputChange} />
                          </div>
                        </div>
                        <div className="col-md-3 col-xs-12">
                          <div className="form-group">
                            <label htmlFor="email">Email <b>*</b></label>
                            <input type="email" className="form-control" id="email" name="email" onChange={this.handleInputChange} />
                          </div>
                        </div>
                        <div className="col-md-3 col-xs-12">
                          <div className="form-group">
                            <label htmlFor="volunteer_area">Volunteer Area</label>
                            <input type="text" className="form-control" id="volunteer_area" name="volunteer_area" onChange={this.handleInputChange} />
                          </div>
                        </div>
                        <div className="col-md-3 col-xs-12">
                          <div className="form-group">
                            <label htmlFor="phone">Phone</label>
                            <input type="text" className="form-control" id="phone" name="phone" onChange={this.handleInputChange} />
                          </div>
                        </div>
                      </div>
                      <div className="form-sec2">
                        <div className="col-md-12 col-xs-12">
                          <textarea className="form-control" name="message" id="message" rows={10} defaultValue={''} onChange={this.handleInputChange} />
                        </div>
                      </div>
                      <div className="form-sec3">
                        <div className="col-md-4 col-xs-12">
                          <button type="submit" id="submit" className="btn btn-primary hvr-sweep-to-right" name="submit" >Send Mail</button>
                        </div>
                      </div>
                      <div id="msgSubmit" className="h3 text-center hidden" />
                    </form>
                  </div>
                </div>
                {/* contact form end */}
              </div>
            </div> {/*/.row*/}
          </div> {/*/.container*/}
        </section>
      </div>);
  }
}

export default Volunteering;



// WEBPACK FOOTER //
// ./src/page/Volunteering.tsx